/**
 *
 * Showcase plugin for Malina 6.9 CMS
 * @copyright ADIT Agency s.r.o.
 * @package: sk.teraz.www
 * @version: 2011_03_13
 */
;
(function ($) {
    //console.log("aaa");
    var Showcase = function () {
        //console.log("bbb");
        var
            currentViewport = 0,
            timer,
            pausedTimer = false,
            maxHeight = 0,
            switchViewport = function (position) {

                if (position == -1)
                    position = $(".topclanok").length - 1;
                else
                    position = position % $(".topclanok").length;

                /*
                 * Bullets
                 */
                $("#Showcase_article_bullets a").removeClass("dot_act").addClass("dot_not");
                $("#Showcase_article_bullets a:eq(" + position + ")").addClass("dot_act").removeClass("dot_not");


                $(".Showcase_articleView").stop().animate({
                    left:-1 * 645 * position
                }, 700, 'easeInOutQuad');

                /*$(".Showcase_articleHolder").stop().animate({
                 height: $(".topclanok:eq("+position+")").attr("desiredHeight")
                 }, 1000, 'easeInOutQuad');*/

                /*$("#topnews").stop().animate({
                 marginBottom: maxHeight - $(".topclanok:eq("+position+")").attr("desiredHeight") + 20
                 }, 1000, 'easeInOutQuad');*/


                if ($("#topArticleKeywordSpan").html() == $("#Articles_topArticle_" + position).attr("tagName")) {
                    $("#topArticleKeywordSpan").stop().animate({
                        opacity:1
                    }, 500);
                }
                else {
                    $("#topArticleKeywordSpan").stop().animate({
                        opacity:0
                    }, 500, function () {
                        $("#topArticleKeywordLink").attr("href", "/tag/" + $("#Articles_topArticle_" + position).attr("tagUrl"));
                        $(this).html($("#Articles_topArticle_" + position).attr("tagName")).animate({
                            opacity:1
                        }, 500);
                    });
                }

                currentViewport = position;

                /*
                 * Autoswitch
                 */
                if (timer != false) {
                    next = currentViewport + 1;
                    timer = setTimeout("$.fn.Showcase({'action':'switchViewport','viewport':" + next + "})", 7000);
                }
            },

            scrollDetection = function () {

                var scrollTop = $(window).scrollTop();

                if (scrollTop > 550 && pausedTimer == false) {
                    //console.log("Pausing timer...");
                    pausedTimer = true;
                    clearTimeout(timer);
                    timer = false;
                }
                else if (scrollTop < 350 && pausedTimer == true) {
                    //console.log("Resuming timer...");
                    pausedTimer = false;
                    timer = setTimeout("$.fn.Showcase({'action':'switchViewport','viewport':" + (currentViewport + 1) + "})", 7000);
                }
            },

            init = function () {
                $(function () {
                    /*
                     * height init
                     */
                    maxHeight = 0;
                    $(".topclanok").css({height:'auto'}).each(function () {
                        //maxHeight = Math.max($(this).find("img").attr("cropped_height"), maxHeight, $(this).height());
                        h = $(this).find("h3").height() + $(this).find("p").height() + 30;
                        hs = Math.max($(this).find("img").attr("cropped_height"), h);
                        maxHeight = Math.max(maxHeight, hs);
                        $(this).attr("desiredHeight", hs);
                    });


                    $(".Showcase_articleHolder").css({
                        //height: $(".topclanok:eq(0)").find("img").attr("cropped_height")//.height()
                        height:maxHeight
                        //height: $(".topclanok:eq(0)").attr("desiredHeight")
                    });

                    /*$("#topnews").css({
                     marginBottom: maxHeight - $(".topclanok:eq(0)").attr("desiredHeight") + 20
                     });*/

                    /*$("#topnewsContainer").css({
                     height: maxHeight + 80
                     });*/


                    /*
                     * Bullets
                     */
                    $("#Showcase_article_bullets a").each(function (i, el) {
                        $(this).click(function () {
                            clearTimeout(timer);
                            timer = false;

                            switchViewport(i);

                            return false;
                        });
                    });


                    /*
                     * Arrows
                     */
                    $("#topnews .leftarrow").click(function () {
                        clearTimeout(timer);
                        timer = false;

                        switchViewport(currentViewport - 1);

                        return false;
                    });

                    $("#topnews .rightarrow").click(function () {
                        clearTimeout(timer);
                        timer = false;

                        switchViewport(currentViewport + 1);

                        return false;
                    });

                    timer = setTimeout("$.fn.Showcase({'action':'switchViewport','viewport':1})", 7000);


                    $(window).scroll(function () {
                        scrollDetection();
                    });

                    scrollDetection();
                });
            };

        //console.log("ccc");

        return {
            bootstrap:function (params) {
                if (typeof(params) == "object") {
                    if (params.action == "switchViewport")
                        switchViewport(params.viewport);
                }
                else
                    init();
                return;
            }
        };
    }();
    //console.log("---");
    $.fn.extend({
        Showcase:Showcase.bootstrap
    });
})(jQuery);
;
